var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 14.25H19C13.7608 14.25 9.5 18.5107 9.5 23.75V90.25C9.5 95.4893 13.7608 99.75 19 99.75H95C100.239 99.75 104.5 95.4893 104.5 90.25V23.75C104.5 18.5107 100.239 14.25 95 14.25ZM95.0048 42.75C95 42.75 95 42.75 95.0048 42.75H92.796L80.1278 23.75H95L95.0048 42.75ZM45.296 42.75L32.6278 23.75H44.9588L57.627 42.75H45.296ZM69.046 42.75L56.3778 23.75H68.7088L81.377 42.75H69.046ZM19 23.75H21.2088L33.877 42.75H19V23.75ZM19 90.25V52.25H95L95.0095 90.25H19Z",
    fill: "#E89005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 85.5L73.625 71.25L47.5 57V85.5Z",
    fill: "#E89005"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSvg);
export default __webpack_public_path__ + "static/media/loginSVG.4c0ce23dc050d54cd62364654d506102.svg";
export { ForwardRef as ReactComponent };